module.exports = __webpack_public_path__ + "static/img/hb_53-min.774e192.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/hb_53-min.png
// module id = 66d3
// module chunks = 1